import React, { Component } from "react";
import { connect } from "react-redux";
import {
  saveDirectoryStateToCache,
  restoreDirectoryStateFromCache,
  openClientEboxViewer
} from "Actions";
import { fetchInfiniteDirectories } from "Thunks";

import DirectoryComponent from "./DirectoryComponent";

class DirectoryContainer extends Component {
  componentDidMount() {
    const { offset, limit, fetchInfiniteDirectories } = this.props;
    fetchInfiniteDirectories({ limit, offset });
  }

  componentDidUpdate(prevProps) {
    const {
      limit,
      selectedClient,
      saveDirectoryStateToCache,
      restoreDirectoryStateFromCache,
      fetchInfiniteDirectories
    } = this.props;

    if (prevProps.selectedClient !== this.props.selectedClient) {
      if (selectedClient) {
        saveDirectoryStateToCache();
        fetchInfiniteDirectories({
          limit,
          offset: 0,
          clientId: selectedClient.id
        });
      } else {
        restoreDirectoryStateFromCache();
      }
    }
  }

  loadMore = () => {
    const {
      offset,
      limit,
      selectedClient,
      fetchInfiniteDirectories
    } = this.props;

    const clientId = selectedClient && selectedClient.id;
    fetchInfiniteDirectories({ limit, offset, clientId });
  };

  handleOpenEbox = lr => {
    const { openClientEboxViewer } = this.props;

    openClientEboxViewer({
      lr,
      isOpen: true
    });
  };

  render() {
    const { directories, fetching, hasMore, language } = this.props;
    return (
      <DirectoryComponent
        directories={directories}
        fetching={fetching}
        loadMore={this.loadMore}
        hasMore={hasMore}
        openEbox={this.handleOpenEbox}
        language={language}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  directories: state.directories.items,
  fetching: state.directories.fetching,
  selectedClient: state.directories.directorySelectedOrg,
  hasMore: state.directories.hasMoreItems,
  offset: state.directories.offset,
  limit: state.directories.limit,
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  fetchInfiniteDirectories: params =>
    dispatch(fetchInfiniteDirectories(params)),
  saveDirectoryStateToCache: () => dispatch(saveDirectoryStateToCache()),
  restoreDirectoryStateFromCache: () =>
    dispatch(restoreDirectoryStateFromCache()),
  openClientEboxViewer: viewer => dispatch(openClientEboxViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DirectoryContainer);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Directory/DirectoryContainer.js